"use client";

import { useTranslations } from "next-intl";

import { AudioGenerationWidget } from "../audio/AudioGenerationWidget";
import type { AudioGenerationWidgetProps, GeneratedSoundItem } from "../audio/AudioGenerationWidget";
import { EventName } from "@mw/shared/analyticsEventNames";

type SoundEffectsGenerationWidgetProps = Omit<AudioGenerationWidgetProps, "showLoopToggle" | "labels" | "eventNames">;

function SoundEffectsGenerationWidget(props: SoundEffectsGenerationWidgetProps) {
  const t = useTranslations("ClientKeys.SoundEffectsGenerationWidget");
  return (
    <AudioGenerationWidget
      {...props}
      showLoopToggle
      eventNames={{
        signUpCtaClicked: EventName.mw_sfx_generation_signup_cta_clicked,
        suggestionPillClicked: EventName.mw_sfx_generation_suggestion_clicked,
      }}
      labels={{
        pillText: t("create_your_own_sfx"),
        headerText: t("generate_sound_effects"),
        placeholder: t("describe_a_sound"),
        loopOn: t("loop_on"),
        loopOff: t("loop_off"),
        loopTooltip: t("looping"),
      }}
    />
  );
}

SoundEffectsGenerationWidget.displayName = "SoundEffectsGenerationWidget";

export { SoundEffectsGenerationWidget };
export type { GeneratedSoundItem, SoundEffectsGenerationWidgetProps };
